import { buscaAutocomplete, triggerSelecao } from '@/common/functions/autocomplete-utils';
import { buscarProdutosSelecao } from '@/common/resources/produto';

export default {
  watch: {
    triggerDivisoes(val) {
      const { divisao } = this.acao;
      if (divisao && divisao.nomExtensao === val) {
        return;
      }
      if (this.timeoutTrigger) {
        window.clearTimeout(this.timeoutTrigger);
      }
      this.timeoutTrigger = window.setTimeout(() => {
        if (val != null) this.buscaDivisoes(val);
      }, 500);
    },
  },
  computed: {
    appendIcon() {
      return !this.somenteLeitura ? 'arrow_drop_down' : '';
    },
    desabilitaDivisao() {
      return this.divisoes.length <= 1;
    },
    desabilitaUnidadeNegocio() {
      const { divisao } = this.acao;
      if (!divisao || !divisao.id || this.unidadesNegocioDivisao.length <= 1) {
        return true;
      }
      return false;
    },
  },
  data() {
    return {
      centroCustoResource: this.$api.centroCusto(this.$resource),
      produtoResource: this.$api.produto(this.$resource),
      tipoBeneficioResource: this.$api.tipoBeneficio(this.$resource),
      planejamentoAcaoResource: this.$api.planejamentoAcaoCadastro(this.$resource),
      divisaoResource: this.$api.divisao(this.$resource),
      caracteresEspeciaisProibidos: '',
      camposFormulario: {
        padrao: [
          {
            labelCampo: 'status',
            tipoCampo: 'TEXTO',
            desAtributos: {
              desabilitado: true,
            },
          },
          {
            labelCampo: 'valor',
            tipoCampo: 'DINHEIRO',
            vlrObrigatorio: true,
            desAtributos: {
              regrasValidacao: [(value) => value <= 99999999.99 || this.$t('message.valor_padrao_maximo')],
            },
          },
          {
            labelCampo: 'tipo_pagamento',
            nomCampoId: 'id_tipo_pagamento',
            tipoCampo: 'LISTA',
            async: {
              fetchFunction: (autocomplete) => this.tipoBeneficioResource.listarAtivos({ autocomplete }),
              itemValue: 'id',
              itemText: 'descricao',
            },
          },
          {
            labelCampo: 'periodo_apuracao',
            tipoCampo: 'MULTIPLA_ESCOLHA',
            vlrObrigatorio: true,
            desAtributos: {
              lista: [
                {
                  valor: 'ANUAL',
                  texto: this.$tc('label.anual', 1),
                },
                {
                  valor: 'SEMESTRAL',
                  texto: this.$tc('label.semestral', 1),
                },
                {
                  valor: 'TRIMESTRAL',
                  texto: this.$tc('label.trimestral', 1),
                },
                {
                  valor: 'MENSAL',
                  texto: this.$tc('label.mensal', 1),
                },
              ],
              textoItem: 'texto',
              valorItem: 'valor',
            },
          },
          {
            labelCampo: 'produto',
            nomCampoId: 'idProduto',
            tipoCampo: 'MULTIPLA_ESCOLHA',
            async: {
              fetchFunction: (autocomplete) => {
                const parametros = {
                  autocomplete,
                  ...this.$refs.container.getValoresDependencias(),
                };
                return buscarProdutosSelecao(parametros, this.$resource);
              },
              itemValue: 'id',
              itemText: 'codigoNome',
            },
          },
        ],
      },
      rules: {
        required: (value) => !!value || this.$t('message.campo_obrigatorio'),
        valorMinimo: (value, min) => value >= min || this.$t('errors.valor.maior_zero_inteiro', { min }),
        requiredFunctionOpcional: (objLabel, valueLabel, obrigatorio) => [
          () => {
            if (!obrigatorio) {
              return true;
            }

            const objeto = this.acao[objLabel] || {};
            const val = objeto[valueLabel];
            const msg = this.$t('message.campo_obrigatorio');
            return !!(val) || msg;
          },
        ],
        requiredFunction: (objLabel, valueLabel) => [
          () => {
            const objeto = this.acao[objLabel] || {};
            const val = objeto[valueLabel];
            const msg = this.$t('message.campo_obrigatorio');
            return !!(val) || msg;
          },
        ],
        naoPermitirCaracteresEspeciais: () => [
          (value) => {
            if (this.somenteLeitura) {
              return true;
            }
            const regexProibidos = new RegExp(`[${this.escapeRegex(this.caracteresEspeciaisProibidos)}]`);
            const msg = this.$t('message.caractere_especial_proibidos_nome_acao');
            return !regexProibidos.test(value) || msg;
          },
        ],
      },
      timeoutTrigger: null,
      listasExtensoesCarteira: {},

      acao: {
        status: 'EM_CADASTRO',
        divisao: null,
        unidadeNegocio: null,
        grupoFornecedor: null,
        fornecedor: null,
        valor: 0,
      },

      divisoesFiltradas: [],
      divisoes: [],
      unidadesNegocioDivisao: [],

      parametrosAplicados: false,
      metadadosParametrizado: null,

      layoutClass: { wrap: true },
      inputLayout: {
        xs12: true,
        sm6: true,
        md3: true,
      },
      definicaoDtaInicio: {
        labelCampo: 'inicio_vigencia',
        nomCampoId: 'dtaInicio',
        tipoCampo: 'DATA',
        vlrObrigatorio: true,
      },
      definicaoDtaFim: {
        labelCampo: 'fim_vigencia',
        nomCampoId: 'dtaFim',
        tipoCampo: 'DATA',
        vlrObrigatorio: true,
      },
    };
  },
  methods: {
    buscaAutocomplete,
    triggerSelecao,
    buscarDivisoes(autocomplete) {
      this.divisoesFiltradas = this.divisoes
        .filter((divisao) => divisao.nome.indexOf(autocomplete) >= 0);
    },
    buscarDivisoesUsuario() {
      this.planejamentoAcaoResource.buscarDivisoes()
        .then((res) => {
          if (!this.novaAcao
            && (this.acao.divisao && this.acao.divisao.id && !res.data.map((d) => d.id).includes(this.acao.divisao.id))) {
            this.permiteAlterarDivisao = false;
          } else {
            this.divisoes = res.data;
            this.divisoesFiltradas = res.data;
            if (this.divisoes.length === 1) {
              const unicaDivisao = this.divisoes[0];
              this.acao.divisao = { ...unicaDivisao };
            }
          }
          this.buscarUnidadesNegocioDivisao();
        })
        .catch((err) => {
          this.$toast(err.data.error);
        });
    },
    buscarUnidadesNegocioDivisao(autocomplete) {
      const idDivisao = this.acao.divisao.id;
      const parametros = { idDivisao, autocomplete };
      return this.planejamentoAcaoResource
        .buscarUnidadesNegocioDivisao(parametros)
        .then((res) => {
          this.unidadesNegocioDivisao = res.data.filter((un) => un.indAtivo);
          if (this.unidadesNegocioDivisao.length === 1) {
            const unicaUnidade = this.unidadesNegocioDivisao[0];
            this.acao.unidadeNegocio = { ...unicaUnidade };
          }
        })
        .catch((err) => {
          this.$toast(err.data.error);
        });
    },
    buscaDivisoes(autocomplete) {
      const parametros = {
        autocomplete,
      };

      if (this.acao.unidadeNegocio) {
        parametros.idUnidadeNegocio = this.acao.unidadeNegocio.id;
      }

      this.divisaoResource.hierarquia(parametros)
        .then((res) => {
          this.divisoes = res.data;
        })
        .catch((err) => {
          this.$toast(err.data.error);
        });
    },
    divisaoAlterada() {
      if (this.acao.unidadeNegocio) {
        this.acao.unidadeNegocio = {};
      }
      if (this.acao.divisao) {
        this.acao.divisao.codNome = this.acao.divisao.id;
        this.buscarUnidadesNegocioDivisao();
      }
    },
    buscarCaracteresEspeciaisProibidos() {
      this.configSistemaResource.buscarChave({ chave: 'CARACTERES_ESPECIAIS_PROIBIDOS_CAMPANHA' })
        .then((resp) => {
          this.caracteresEspeciaisProibidos = resp.bodyText;
        });
    },
    escapeRegex(string) {
      return string.replace(/[/\-\\^$*+?.()|[\]{}]/g, '\\$&');
    },
  },
  mounted() {
    this.buscarCaracteresEspeciaisProibidos();
  },
};
